import { render, staticRenderFns } from "./ProductsWarehouse.vue?vue&type=template&id=d5c1a99a&scoped=true"
import script from "./ProductsWarehouse.vue?vue&type=script&lang=ts"
export * from "./ProductsWarehouse.vue?vue&type=script&lang=ts"
import style0 from "./Goods.scss?vue&type=style&index=0&id=d5c1a99a&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5c1a99a",
  null
  
)

export default component.exports